import InlineSvg from "../lib/InlineSvg.tsx";
import TextSlideView from "../lib/TextSlideView.tsx";
import type { TextSlideData } from "../lib/text-slide.ts";
import type { ResolveItem } from "../lib/types.ts";

// Full-screen renderer for one resolved item. Sized to fill the TV; the AI
// composer and text slides are authored to the display's orientation.
export default function Slide({ item }: { item: ResolveItem }) {
  switch (item.type) {
    case "image": {
      // Decorative on a kiosk TV, so an empty alt is right there — but the
      // player also runs in a normal browser tab when someone is checking a
      // screen, and a description costs nothing to carry.
      const alt = (item.data as { alt?: string } | undefined)?.alt?.trim() ?? "";
      return <img className="slide slide-media" src={item.url} alt={alt} />;
    }
    case "video":
      return (
        <video
          className="slide slide-media"
          src={item.url}
          autoPlay
          muted
          loop
          playsInline
        />
      );
    case "svg": {
      const svg = (item.data as { svg?: string } | undefined)?.svg ?? "";
      // Scoped ids: the outgoing slide is still mounted underneath this one,
      // and two slides that both name a gradient `#sky` would otherwise share
      // whichever came first.
      return <InlineSvg className="slide slide-svg" svg={svg} />;
    }
    case "text":
      return (
        <TextSlideView
          slide={(item.data ?? {}) as TextSlideData}
          fit="fill"
          className="slide"
        />
      );
    default:
      return null;
  }
}
